/** Parses an ISO date (YYYY-MM-DD) into UTC year/month/day parts. Returns null for anything unparseable. */
export function parseIsoDate(value: string | null): { year: number; month: number; day: number } | null {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return { year, month, day };
}

/** Age in whole years as of the group effective date (product plan 4.1). Null when the birth date is missing. */
export function ageAsOf(dateOfBirth: string | null, effectiveDate: string): number | null {
  const birth = parseIsoDate(dateOfBirth);
  const asOf = parseIsoDate(effectiveDate);
  if (!birth || !asOf) return null;

  let age = asOf.year - birth.year;
  const birthdayNotReached = asOf.month < birth.month || (asOf.month === birth.month && asOf.day < birth.day);
  if (birthdayNotReached) age -= 1;
  return Math.max(age, 0);
}

export function isJuvenile(age: number | null): boolean {
  return age !== null && age < 18;
}

export function birthYearOf(dateOfBirth: string | null): number | null {
  return parseIsoDate(dateOfBirth)?.year ?? null;
}
